import script from "./ProductDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetails.vue?vue&type=style&index=0&id=e1e49348&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1e49348"]])

export default __exports__